/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Features_EyebrowInputs */

const en_portal_features_eyebrow = /** @type {(inputs: Portal_Features_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

const pl_portal_features_eyebrow = /** @type {(inputs: Portal_Features_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcje`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {Portal_Features_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_features_eyebrow = /** @type {((inputs?: Portal_Features_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Features_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_features_eyebrow(inputs)
	return en_portal_features_eyebrow(inputs)
});